import { API, API_POST } from "../../config";

export const AddFAQ = (payload) => {
  const f = new FormData();

  f.append("question", payload.question);
  f.append("answer", payload.answer);
  
  return API_POST(API.AddFaq,f);
};